import { createSlice } from "@reduxjs/toolkit";
import { actionFecthWalletBalance } from "../action/OtcAction";

const initialState = {
    userWalletbaalnceData: null,
    loading: false,
    error: null,
    emailDetails: {
        id: null,
        email: null,
    }, 
};

const otcSlice = createSlice({
    name: "otc",
    initialState,
    reducers: {
        saveEmailDetails: (state, { payload }) => {
            state.emailDetails = payload;
        },
    },
    extraReducers: (builder) => {
        builder
            // Handle actionFecthWalletBalance
            .addCase(actionFecthWalletBalance.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(actionFecthWalletBalance.fulfilled, (state, action) => {
                state.loading = false;
                state.userWalletbaalnceData = action.payload;
                state.error = null;
            })
            .addCase(actionFecthWalletBalance.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                state.userWalletbaalnceData = null;
            });
    },
});

export const {
    saveEmailDetails
} = otcSlice.actions;

export default otcSlice.reducer;